import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { SewButton, SewHeadline, SewInput } from '@sew/ui-components-angular/standalone';
import { takeUntil } from 'rxjs/operators';
import {
    InjectionData,
    MODAL_CONTENT_TOKEN,
} from '../../../../../../../lib-os-components/src/lib/services/modal/modal.helper';
import { OnDestroyBase } from '../../../../../../../lib-os-components/src/public-api';
import { BlogLabels } from '../../../../models/label.model';
import { BlogService } from '../../../../services/blog/blog.service';

export interface DialogData {
    isArticle: boolean;
}

@Component({
    selector: 'blog-dialog-name',
    templateUrl: './dialog-name.component.html',
    styleUrls: ['./dialog-name.component.scss'],
    imports: [CommonModule, SewHeadline, SewInput, SewButton],
})
export class DialogNameComponent extends OnDestroyBase implements OnInit, OnDestroy {
    public labels: BlogLabels = {} as BlogLabels;
    public isArticle: boolean;

    public value = '';

    public constructor(
        @Inject(MODAL_CONTENT_TOKEN)
        private injection: InjectionData<DialogData, any>,
        private blogService: BlogService
    ) {
        super();
        this.isArticle = !!this.injection.data?.isArticle;
    }

    public ngOnInit(): void {
        this.initLabels();
    }

    public onNoClick(): void {
        this.injection.close();
    }

    public onYesClick(): void {
        this.injection.close(this.value);
    }

    public setValue(value: string) {
        this.value = value;
    }

    private initLabels(): void {
        this.blogService.labelsUpdated.pipe(takeUntil(this.destroySubject)).subscribe((labels) => {
            this.labels = labels;
        });
    }
}
